import { StackScreenProps } from "@react-navigation/stack";
import { CustomerListFilterRootParamList } from "../../../../types";
import { useTranslation } from "../../../../utilities/i18n";
import { useGenericFilterListScreen } from "../../../../components/GenericFilterListScreen";
import { useListFilterContext } from "../../../../utilities/list-filter/use-list-filter-context";
import { CustomerFilterValues } from "../../types";
import {
  Card,
  FlatActionList,
  Page,
  Stack,
  Switch,
} from "@towersystems/roam-common-native";
import { View } from "react-native-ui-lib";

export interface CustomerListFilterScreenProps
  extends StackScreenProps<
    CustomerListFilterRootParamList,
    "CustomerListFilterScreen"
  > {}

export const CustomerListFilterScreen = ({}: CustomerListFilterScreenProps) => {
  const { t } = useTranslation("customer");

  const { filterState, setFilterValue, clearAll, watch } =
    useListFilterContext<CustomerFilterValues>();

  const { isRetailerCusAccount, nonRetailerCustomer } = watch();

  return (
    <Page
      title={t("select_product_filter_title")}
      secondaryTitle={t("select_product_filter_subtitle")}
    >
      <Stack vertical>
        <Card>
          <FlatActionList
            items={[
              {
                key: "filter_account_customer",
                title: t("action.filter_account_customer.label"),
                subTitle: t("action.filter_account_customer.description"),
                isAction: isRetailerCusAccount,
                componentRight: (icon) => {
                  return (
                    <View>
                      <Switch
                        value={isRetailerCusAccount}
                        onValueChange={() => {
                          setFilterValue(
                            "isRetailerCusAccount",
                            !isRetailerCusAccount
                          );
                        }}
                      />
                    </View>
                  );
                },
              },
              {
                key: "filter_non_retailer_customer",
                title: t("action.filter_non_retailer_customer.label"),
                subTitle: t("action.filter_non_retailer_customer.description"),
                isAction: nonRetailerCustomer,
                componentRight: (icon) => {
                  return (
                    <View>
                      <Switch
                        value={nonRetailerCustomer}
                        onValueChange={() => {
                          setFilterValue(
                            "nonRetailerCustomer",
                            !nonRetailerCustomer
                          );
                        }}
                      />
                    </View>
                  );
                },
              },
            ]}
          />
        </Card>
      </Stack>
    </Page>
  );
};
